export function storeLastProduct(id: string, catalogId: string) {
	localStorage.setItem(`plp-product-${catalogId}`, id)
}
